module.exports = __webpack_public_path__ + "img/pharmacie.fa77fd48.png";